/** PSD encoding over the shared browser capture and text-measurement pipeline. */
import { writePsdUint8Array } from "ag-psd";
import { buildAiDisclosureXmp } from "@hightouch/lib/ad-studio/disclaimer/xmp";
import {
  withPreparedLayeredExport,
  type LayeredExportArgs,
} from "src/pages/ad-studio/layered-export/prepare-layered-export";
import {
  buildPsdDocument,
  trimmedPlacement,
} from "src/pages/ad-studio/psd-export/build-psd-document";
import { buildCanvasFontMetricsResolver } from "@hightouch/lib/ad-studio/psd-export/psd-font-metrics";
export const PSD_MIME_TYPE = "image/vnd.adobe.photoshop";
export function buildPsdBlob(args: LayeredExportArgs): Promise<Blob> {
  return withPreparedLayeredExport(
    args,
    async ({ doc, composite, measurements, rasterizeDoc, disclosure }) => {
      const psd = await buildPsdDocument({
        doc,
        composite,
        rasterizeDoc,
        textOptions: {
          resolveFont: args.resolveFont,
          measureFont: buildCanvasFontMetricsResolver(),
          measurements,
        },
      });
      if (args.machineReadableDisclosure)
        psd.imageResources = {
          ...psd.imageResources,
          xmpMetadata: buildAiDisclosureXmp(),
        };
      const overlay = disclosure && trimmedPlacement(disclosure);
      if (overlay) psd.children.push({ name: "AI disclosure", ...overlay });
      const bytes = writePsdUint8Array(psd, {
        generateThumbnail: true,
        invalidateTextLayers: true,
      });
      // Copied: the writer returns a view into its own buffer; BlobPart needs a plain one.
      return new Blob([new Uint8Array(bytes)], { type: PSD_MIME_TYPE });
    },
  );
}
